import { render } from "./flatPage.vue?vue&type=template&id=3dfb0393"
import script from "./flatPage.vue?vue&type=script&lang=js"
export * from "./flatPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__